import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { BookmarkCategoryState } from './bookmark-category.state';
import { BookmarkCategory } from '../../models/bookmark-category';

export function withBookmarkCategorySelectors() {
  return signalStoreFeature(
    {
      state: type<BookmarkCategoryState>(),
    },
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items()) as BookmarkCategory[]),
      asSortedArray: computed(() => {
        return Object.values(items())
          .filter(item => {
            return !item.private;
          })
          .sort((obj1, obj2) => {
            return obj1.sorting - obj2.sorting;
          }) as BookmarkCategory[];
      }),
      private: computed(
        () =>
          Object.values(items())
            .filter(item => {
              return item.private;
            })
            .sort((obj1, obj2) => {
              return obj1.sorting - obj2.sorting;
            }) as BookmarkCategory[]
      ),
      allKeys: computed(
        () =>
          Object.values(items())
            .map(item => {
              return item._id;
            })
            .concat(['private', 'unsorted']) as string[]
      ),
    }))
  );
}
